import { jsx as t, Fragment as y, jsxs as d } from "react/jsx-runtime";
import n from "./styles.module.less.js";
import { useMemo as f, useState as I, useRef as k } from "react";
import { useOnClickOutside as N } from "../../../../utils/on-click-outside.js";
import v from "../folder.svg.js";
import C from "../settings.svg.js";
import S from "../logout.svg.js";
import { useScreenSize as O, WidthType as b } from "../../../../utils/use-is-mobile.js";
import { MenuItem as A } from "../menu-item/index.js";
import { UserImage as T } from "./user-image.js";
import { MobileMenuDropdown as w } from "../mobile-menu-dropdown/index.js";
import { getAccountUrls as x } from "../../../../utils/webapp-chat-url.js";
const K = (m) => {
  const {
    userImage: r,
    logout: i,
    hasNotifications: c,
    isActive: p,
    isScrolledHeader: a,
    getTranslation: o,
    closeMenuModal: g,
    language: l,
    newChatUrl: u
  } = m, { myCasesUrl: s, settingsUrl: e } = x({
    origin: u,
    language: l
  }), h = O(), M = f(() => h === b.Mobile, [h]), U = f(
    () => [
      // {
      //   title: getTranslation('account.new-case'),
      //   icon: (
      //     <div className={styles.newCaseWrapper}>
      //       <div className={styles.newCaseIconPosition}>
      //         <PlusIcon className={styles.newCaseIcon} />
      //       </div>
      //       <div className={styles.newCaseIconPosition}>
      //         <img src={PlusIconHover} className={styles.newCaseIconHover} />
      //       </div>
      //     </div>
      //   ),
      //   path: '/chat?newCase=true',
      //   isGradient: true,
      // },
      {
        title: o("account.my-cases"),
        icon: /* @__PURE__ */ t(v, { className: n.menuIcon }),
        path: s
      },
      {
        title: o("account.settings"),
        icon: /* @__PURE__ */ t(C, { className: n.menuIcon }),
        path: e
      },
      {
        title: o("account.sign-out"),
        icon: /* @__PURE__ */ t(S, { className: n.menuIcon }),
        onClick: i
      }
    ],
    [o, i, s, e]
  );
  return M ? /* @__PURE__ */ t(
    D,
    {
      userImage: r,
      hasNotifications: c,
      getTranslation: o,
      logout: i,
      closeMenuModal: g,
      myCasesUrl: s,
      settingsUrl: e
    }
  ) : /* @__PURE__ */ t(
    L,
    {
      isScrolledHeader: a,
      isActive: p,
      userImage: r,
      hasNotifications: c,
      menuItems: U,
      getTranslation: o,
      accountUrl: s
    }
  );
}, D = (m) => {
  const {
    userImage: r,
    hasNotifications: i,
    getTranslation: c,
    logout: p,
    closeMenuModal: a,
    myCasesUrl: o,
    settingsUrl: g
  } = m, [l, u] = I(!1), s = k(null), e = () => {
    u(!l), a == null || a();
  };
  return N(s, () => u(!1)), /* @__PURE__ */ t(
    w,
    {
      items: [
        {
          title: c("account.my-cases"),
          link: o,
          icon: v
        },
        {
          title: c("account.settings"),
          link: g,
          icon: C
        },
        {
          title: c("account.sign-out"),
          onClick: p,
          icon: S
        }
      ],
      toggleOpen: e,
      isOpen: l,
      menuWrapperRef: s,
      children: /* @__PURE__ */ t(T, { userImage: r, hasNotifications: i })
    }
  );
}, L = (m) => {
  const {
    isScrolledHeader: r,
    isActive: i,
    userImage: c,
    hasNotifications: p,
    menuItems: a,
    getTranslation: o,
    accountUrl: g
  } = m, [l, u] = I(!1), s = k(null);
  return N(s, () => u(!1)), /* @__PURE__ */ t("div", { className: n.menuWrapper, ref: s, children: /* @__PURE__ */ t(
    A,
    {
      label: o("pages.account"),
      chevronStyle: "rotate",
      hasShrunk: r,
      isActive: i,
      classNames: {
        wrapper: n.accountLinkWrapper,
        childContainer: `${n.hoverMenu} ${r ? n.scrolledHeader : ""} ${l ? n.forceOpen : ""}`,
        labelTitle: n.accountLabelTitle,
        chevronIcon: n.chevronIcon
      },
      icon: /* @__PURE__ */ t(
        T,
        {
          userImage: c,
          hasNotifications: p
        }
      ),
      path: g,
      children: /* @__PURE__ */ t(y, { children: a.map(
        (e) => e.path ? /* @__PURE__ */ d("a", { href: e.path, className: n.menuItem, children: [
          /* @__PURE__ */ t(
            "span",
            {
              className: `${n.menuItemText} ${e.isGradient ? n.gradientText : ""}`,
              children: e.title
            }
          ),
          e.icon
        ] }, e.title) : e.onClick ? /* @__PURE__ */ d(
          "div",
          {
            onClick: e.onClick,
            className: n.menuItem,
            children: [
              /* @__PURE__ */ t("span", { className: n.menuItemText, children: e.title }),
              e.icon
            ]
          },
          e.title
        ) : null
      ) })
    }
  ) });
};
export {
  K as AuthenticatedAccountLink
};
